import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "email-confirmed-thank-you",
  class: "flex flex-column text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "mt-5" }, "Your email was confirmed!", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Thank you for confirming your email. You can now start using SquadronBase.", -1)

import { useRouter } from 'vue-router';
import Button from 'primevue/button';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailConfirmThankYouView',
  setup(__props) {

const router = useRouter();

const onGoToBase = () => {
  router.push({ name: 'base' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_unref(Button), {
      label: "Go to SquadronBase",
      class: "mx-auto",
      onClick: onGoToBase
    })
  ]))
}
}

})